const SKIP_CACHE_PARAM = 'skipDRSettingsCache';

/**
 * Returns the cache-busting value sent as `nocache` on DR Admin config requests, opted into
 * with the `skipDRSettingsCache=true` URL parameter. A fresh value per request guarantees the
 * response is not served from the API Gateway cache.
 *
 * @returns {string|null} Cache-buster value, or `null` when the parameter is not set.
 */
export const getDrSettingsCacheBuster = () => {
	try {
		const { searchParams } = new URL(window.location.href);

		return searchParams.get(SKIP_CACHE_PARAM) === 'true' ? String(Date.now()) : null;
	} catch {
		return null;
	}
};
